import styled from 'styled-components';

const CloseButton = styled.button`
  ${({ theme }) => theme.fontFamily.mainFont.xSmallExtraBold};
  color: ${({ theme }) => theme.colors.night_blue_1};
  position: absolute;
  top: 30px;
  right: 24px;
  background: transparent;
`;

export default CloseButton;
